import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ProjectProgress from '../../Project/ProjectProgress/ProjectProgress';

const steps = ["Uppstart", "Implementation", "Information", "Utbildning", "Uppföljning"];

const getSettings = (layout, other) => {
  const { fontColor, name } = layout;

  return { fontColor, name, ...other }
};

const ProjectProgressWidget = ({ layout }) => {
  const settings = getSettings(layout);

  const sxContainer = {
    backgroundColor: "transparent",
    color: settings.fontColor,
    display: "flex",
    flexGrow: 1,
    p: 2,
    "& > div": {
      width: "100%",
    },
  };

  const sxTitle = {
    fontSize: "16px",
    margin: "0px",
    padding: "0px 8px 8px 8px",
    textAlign: "center",
  };

  return (
    <Box sx={sxContainer}>
      <Box component="div">
        <Typography variant="body1" sx={sxTitle}>
          {settings.name}
        </Typography>
        <ProjectProgress steps={steps} initialActiveStep={1} initialProgress={30} />
      </Box>
    </Box>
  );
};

export default ProjectProgressWidget;
